import { moduleLogger } from "./Logger";
import { ApiClient } from "./api/ApiClient";
import { BenefitActivationClient } from "./api/BenefitActivationClient";
import { BenefitCache } from "./benefit/BenefitCache";
import { BenefitService } from "./benefit/BenefitService";
import { TrackingService } from "./tracking/TrackingService";
import { AppButton } from "./util/AppButton";
const log = moduleLogger.scope("init");

const apiClient = new ApiClient();

const benefitService = new BenefitService(new BenefitCache(apiClient), new TrackingService(), apiClient, new BenefitActivationClient(), new AppButton());

void benefitService.registerEventListener().then(() => log.info("Registered event listener for detailview on BenefitService"));
